/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class HarlequinSoundConfig implements ISoundConfig {

    public static instance:HarlequinSoundConfig = new HarlequinSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    RESPIN_AMBIANCE:string = "background-music-respin";
    FREESPIN_AMBIANCE:string = "background-music-fs";

    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    BETLINE_TICK:string = "betlineHighlight";
    COUNTUP:string = "countup";
    COUNTUP_ENDS:string = "countupEnds";

    BIG_WIN:string = "bigwin";
    BIG_WIN_COUNTUP:string = "bigwinCountup";
    BIG_WIN_ENDS:string = "bigwinEnds";
    BIG_WIN_LEVEL_1:string = "bigwinLevel1";
    BIG_WIN_LEVEL_2_3:string = "bigwinLevel2And3";
    BIG_WIN_INITIAL:string = "bigwinInitialWin";

    WILD_LAND:string = "wildLanding";
    WILD_NUDGE_1:string = "wildNudge1";
    WILD_NUDGE_2:string = "wildNudge2";
    WILD_FLAP:string = "wildRollDown";
    WILD_NUDGE_ABORT:string = "wildNudgeAbort";

    RESPIN_INTRO:string = "respinIntro";
    RESPIN_OUTRO:string = "respinOutro";

    WILD_STEP:string = "wildMoves";
    WILD_MULTIPLIER:string = "wildMultiplier";

    FREESPIN_INTRO:string = "fsIntro";
    FREESPIN_OUTRO:string = "fsEnds";
    FREESPIN_OUTRO_ENDS:string = "fsEndsOutro";

    RESPIN_OUTRO_FAIL:string = "respinOutroNoWIn";


    // REELS_SPIN_START?:string[];
    //REELS_SPINNING:string = "reelsSpinning";
    // REELS_SPIN_START:string[] = ["reelsSpinning"];
    REELS_DEFAULT_BOUNCE:string [] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    SCATTER_LAND:string [] = ["scatter1", "scatter2", "scatter3"];
    SCATTER_LIT:string = "scatterHighlight";
    SCATTER_COLLECT:string = "scatterCollect";
    SCATTER_FS_LAND:string = "fsWildLanding";
    SCATTER_PLUS:string  = "plusSpin";

    ANTICIPATION:string = "anticipation";
    ANTICIPATION_FAIL:string = "anticipationFail";
    // REELS_DEFAULT_STOP?:string[];
    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinning";

    CONTINUE:string = "continueButton";

    constructor() {
        if(HarlequinSoundConfig.instance) {
            throw new Error("HarlequinSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}